import React from 'react';
import ErrorModal from './errorModal';
import { ERROR_CONSTANTS, ERROR_MSG, ERROR_MSG_DISPLAY } from './errorBoundaryConstant';
import { paths } from '../../routes/routesConfig';
import { clearAuthToken } from '../../services/authService';
import { genericLogout } from '../../app/appHelper';
import { getClonedStringFromStorage } from '../../services/storageService';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { errorReset } from './errorHandlerSlice';
import { toggleForceLogout } from '../Login/loginSlice';

const ErrorHandler: React.FC = () => {
  const displayMessage = useSelector((state: RootState) => state.error.msg);
  const errorCode = useSelector((state: RootState) => state.error?.errorCode);
  const forcedLogout = useSelector((state: RootState) => state.login.forcedLogout);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const resetError = () => {
    const tenantCodeCopyToRedirect = getClonedStringFromStorage('tenant');
    ERROR_CONSTANTS.UNAUTHORIZED.forEach((msg) => {
      if (displayMessage === msg) {
        genericLogout(null, navigate, tenantCodeCopyToRedirect);
      }
    });
    dispatch(errorReset());
  };

  const redirectToLogin = (errorMessage) => {
    clearAuthToken();
    resetError();
    if (!forcedLogout && errorMessage === ERROR_MSG.singleLogin) dispatch(toggleForceLogout());
    const tenant = getClonedStringFromStorage('tenant');
    navigate(`${paths.login}${tenant && '?tenant_code=' + tenant}`);
  };

  const displayMessageFn = () => {
    let flag = false;
    ERROR_CONSTANTS.UNAUTHORIZED.forEach((msg) => {
      if (displayMessage === msg) {
        flag = true;
      }
    });
    return flag ? ERROR_MSG_DISPLAY.displayMessage : displayMessage;
  };

  const displayMessageOnModal = displayMessageFn();

  if (Object.values(ERROR_MSG).includes(displayMessage) || errorCode === '002007') {
    redirectToLogin(displayMessage);
    return null;
  }

  return <ErrorModal errorMessage={displayMessageOnModal} resetError={resetError} />;
};

export default ErrorHandler;
